export default __webpack_public_path__ + "static/media/logo.1bd4b46c.webp";